import type { PaymentPromotionFilter, PaymentPromotionsFromBackend } from './types';

import type { ServiceConfig } from '../../utils/create-http-api-service';
import { STRAPI_URL } from '../constants';
import { getStrapiQueryParams } from '../utils/query-params';
import { strapiServiceAdapter } from '../utils/strapi-service-adapter';
import { transformPaymentPromotions } from './transform';

export const getPaymentPromotions = (filter?: PaymentPromotionFilter) => (
  function getPaymentPromotionsService({ brandName, language, instance, region }: ServiceConfig) {
    type AdapterProps = { response: PaymentPromotionsFromBackend };

    const queryParams = getStrapiQueryParams({ language, region, brandName });
    filter && queryParams.set(`filters[${filter}]$eqi]`, 'true');
    queryParams.set('populate', 'banner');

    const url = `${STRAPI_URL.PAYMENT_PROMOTIONS}?${queryParams.toString()}`;

    return strapiServiceAdapter<AdapterProps, ReturnType<typeof transformPaymentPromotions>>(
      url,
      instance.get,
      { responseHandler: transformPaymentPromotions },
    );
  }
);
